export default "__VITE_ASSET__BUJ0Pukv__"